"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorInputLabel = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _colorPickerTheme = require("../../../../colorPickerTheme");
const ColorInputLabel = (0, _styled.default)("label")`
    font-style: normal;
    font-weight: normal;
    font-size: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _colorPickerTheme.colorPickerTheme.colorInput.label.fontSize(themeMode);
}};
    line-height: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _colorPickerTheme.colorPickerTheme.colorInput.label.lineHeight(themeMode);
}};
    color: ${(0, _designTokensReact.color)("color--text--neutral--strong")};
    flex: ${_ref3 => {
  let {
    flexGrow,
    width
  } = _ref3;
  return `${flexGrow} 0 ${isNaN(+width) ? width : `${width}px`}`;
}};
    margin-bottom: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _colorPickerTheme.colorPickerTheme.colorInput.label.marginBottom(themeMode);
}};
    display: flex;
    flex-direction: column;
    gap: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _colorPickerTheme.colorPickerTheme.colorInput.label.gap(themeMode);
}};
`;
exports.ColorInputLabel = ColorInputLabel;
//# sourceMappingURL=ColorInputLabel.js.map